import type { User } from '@/models/types';

const getCallMeBy = (
  user: Pick<User, 'username' | 'first_name' | 'last_name'>,
): string => {
  if (user.username) {
    return user.username;
  }

  return `${user.first_name} ${user.last_name}`;
};

export default getCallMeBy;
